/** Health tier options for filter (match list_metadata.health_tier from recipe_health_tier_service). */
export const HEALTHINESS_OPTIONS = [
  { slug: 'junk_food_delicious', label: 'Junk Food', hearts: 1 },
  { slug: 'wont_clog_arteries', label: "Won't Clog Arteries", hearts: 2 },
  { slug: 'straight_up_healthy', label: 'Straight Up Healthy', hearts: 3 },
]

export const CUISINE_OPTIONS = [
  'American', 'Brazilian', 'British', 'Cajun', 'Caribbean', 'Chinese', 'Ethiopian',
  'Filipino', 'French', 'Fusion', 'German', 'Greek', 'Indian', 'Italian', 'Japanese',
  'Korean', 'Mediterranean', 'Mexican', 'Middle Eastern', 'Moroccan', 'Peruvian', 'Southern',
  'Spanish', 'Swedish', 'Tex-Mex', 'Thai', 'Turkish', 'Vietnamese',
]

/** Max total time (prep + cook); null means no time filter selected. */
export const TIME_OPTIONS = [
  { label: '15 min or less', value: 15 },
  { label: '30 min or less', value: 30 },
  { label: '45 min or less', value: 45 },
  { label: '1 hr or less', value: 60 },
  { label: '1½ hrs or less', value: 90 },
]
